export default __webpack_public_path__ + "static/media/Rabi_2020-21.0ccbea18.webm";